<template>
  <v-list class="tech_user_bar">
    <v-divider vertical :thickness="2"></v-divider>

    <!-- Notifications Item -->
    <v-list-item id="tech_notifications_icon" class="tech_notifications_item">
      <UserNotifications />
    </v-list-item>

    <!-- Account Button Item -->
    <v-btn v-if="userProfileItem" class="tech_bar_button weg_translate" variant="flat" color="primary-800" :to="userProfileItem.href" :ripple="true" rounded="xl">
      <span>Profile</span>
      <v-avatar :image="getResourceUrl(profileImgUrl)" size="38" rounded="xl"></v-avatar>
      <v-tooltip activator="parent" location="bottom" class="hidden-xs">Visit Your Profile</v-tooltip>
    </v-btn>
  </v-list>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useUserDataStore } from '@/store/userDataStore';
import { getResourceUrl } from '@/services/admin_actions/apiUtils';
import UserNotifications from '../SingleElements/UserNotifications.vue';
import { useRoute } from 'vue-router'; // Import Vue Router for routing

const userDataStore = useUserDataStore(); // Access the Pinia store
const siteMap = computed(() => userDataStore.menuData.site_map); // Access the siteMap from the Pinia store
const route = useRoute(); // Vue router route object

/* --------------------------------------------------------- */
// Computed property to get users profile data from the siteMap
const userProfileItem = computed(() => {
  const isLoggedIn = siteMap.value?.hasOwnProperty('Profile');
  const item = isLoggedIn ? siteMap.value['Profile'] : siteMap.value['Log in'];

  // Construct the dynamic URL if both 'href' and 'playerid' are available
  const dynamicHref = item?.href && item?.playerid ? `${item.href}?player=${item.playerid}` : item?.href || '/menu_login?action=logout&referer=' + route.path;

  // Return the updated userProfileItem with the dynamic URL
  return item ? { ...item, href: dynamicHref } : { href: '/menu_login?action=logout&referer=' + route.path };
});
/* End */

// Computed property to get the dynamic image URL for the 'Profile' menu item
const profileImgUrl = computed(() => {
  const profileImg = userDataStore.menuData.top_menu_items.Profile?.img;
  const loginImg = userDataStore.menuData.top_menu_items['Log in']?.img;

  let imgUrl = profileImg || loginImg; // Use profile image if available, otherwise use login image

  // Ensure there is always a leading slash in the img URL and handle null
  if (!imgUrl) return '/maya/icons/login-icon.png'; // Specify a default image path if no URL is present
  return imgUrl.startsWith('/') ? imgUrl : '/' + imgUrl;
});
</script>

<style lang="scss">
// Style the User Tech Bar Component to have a transparent background and no padding
.tech_user_bar {
  display: flex;
  gap: 5px;
  background-color: transparent;
  padding: 0px;
  height: 64px;
  width: 100%;
  flex-direction: row;
  align-content: center;
  justify-content: flex-end;
  align-items: center;
}

// Style the User Tech Bar List Items to have a transparent background and no padding
#tech_notifications_icon {
  padding: 0px;
  width: 60px;
}

// Show notifications Bubble correctly and add width to icon div
.tech_notifications_item .v-list-item__content {
  overflow: unset;
}

.tech_bar_button {
  padding: 0px 0px 0px 10px;
  font-size: 11px;
  line-height: 0;
  font-family: $brandon-grotesque-font;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  margin: 0px;
  height: auto !important;
  .v-btn__content {
    padding: 0px;
    gap: 5px;
  }
  .v-avatar {
    border: solid 4px;
    border-color: rgba(var(--v-theme-primary));
  }
}

// Media Query to control User Tech Bar elements on Screens less than 1100px
@media only screen and (max-width: $mobile-screen) {
  // Remove padding from Notifications Icon on Screens less than 1100px
  #tech_notifications_icon {
    padding-right: 0px;
    width: 50px;
  }
  // Style the Profile button on mobile
  .tech_bar_button {
    padding: 0px 0px 0px 10px;
    margin: 0px 5px 0px 0px;
  }
}

@media only screen and (max-width: $small-screen) {
  .tech_user_bar {
    height: 50px;
  }
}

//notifications style needed here because of scoped style in child element
.v-overlay .v-overlay__content:has(.tech_notifications_panel) {
  @media only screen and (max-width: $small-screen) {
    width: 100%;
    left: 0;
    right: 0;
  }
}
</style>
